export default {
      id: "tt-strike-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#tt-strike",
      toString: function () {
        return this.url;
      }
    }